import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import EmptyLayout from '../layouts/EmptyLayout';
import QcBarcodes from '../components/clinicPortal/qc/qcSampleGrid/qcBarcodes';

class EmptyRouter extends Component {
    render(props) {
        return (
            <EmptyLayout>
                <Switch>
                    <Route path="/common/qcBarcodes/:barcodes" exact component={QcBarcodes} />
                </Switch>
            </EmptyLayout>
        );
    }
}

export default EmptyRouter;
